import { createContext, useContext, useState } from 'react'

const PageTitleContext = createContext(null)

export const usePageTitle = () => {
  const context = useContext(PageTitleContext)
  if (context === undefined || context === null) {
    throw new Error('usePageTitle must be used within a PageTitleProvider')
  }
  return context
}

export const PageTitleProvider = ({ children }) => {
  const [PageTitle, setPageTitle] = useState('')
  const [breadcrumbs, setBreadcrumbs] = useState([])

  return (
    <PageTitleContext.Provider value={{ PageTitle, setPageTitle, breadcrumbs, setBreadcrumbs }}>
      {children}
    </PageTitleContext.Provider>
  )
}
